import { useEffect, useState } from 'react';

import { getUsersDetails } from '../services/api';
import { getBulkUsers } from '../services/jira';
import { JiraUser, LastUserEntryDetails } from '../types';

interface UserInfo {
  [key: string]: JiraUser;
}

function createUsersMap(users: JiraUser[]) {
  return users.reduce<UserInfo>((all, user) => {
    all[user.accountId] = user;
    return all;
  }, {});
}

export const useLastUserEntries = () => {
  const [entries, setEntries] = useState<LastUserEntryDetails[]>([]);
  const [users, setUsers] = useState<UserInfo>({});
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<string | undefined | null>(null);

  async function getLastEntries() {
    try {
      setLoading(true);
      const { users, lastEvaluatedKey } = await getUsersDetails(lastKey);
      setLastKey(lastEvaluatedKey);

      const accountIds = [...new Set(users.map((e) => e.accountId))];
      if (accountIds.length) {
        const { values } = await getBulkUsers({
          accountIds,
        });
        const usersInfoMap = createUsersMap(values);
        setUsers((prev) => ({ ...prev, ...usersInfoMap }));
      }
      setEntries((prev) => [...prev, ...users]);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void getLastEntries();
  }, []);

  return {
    entries,
    users,
    loading,
    hasMore: lastKey !== undefined,
    loadMore: () => {
      void getLastEntries();
    },
  };
};
